import apiClient from "./apiClient"

export interface AuditRow {
    id: string
    date: string
    amount_minor: number | null
    currency: string | null
    previous_hash: string | null
    hash: string | null
    status: "ok" | "err"
    ticket_ref: string | null
    movement_type?: string | null
    direction?: string | null
    register_id?: string | null
    session_id?: string | null
    cashier?: string | null
}

export type AuditType = "payments" | "transactions" | "mouvements"

export interface AuditPage {
    rows: AuditRow[]
    total: number
    page: number
    pageSize: number
}

interface AuditFilters {
    dateFrom: string
    dateTo: string
    page: number
    pageSize: number
}

async function getAudit(
    companyId: string,
    type: AuditType,
    filters: AuditFilters
): Promise<AuditPage> {
    const params = new URLSearchParams({
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        page: String(filters.page),
        pageSize: String(filters.pageSize),
    })
    const response = await apiClient.get(
        `/api/companies/${companyId}/hash-audit/${type}?${params.toString()}`
    )
    return {
        rows: response.rows || [],
        total: Number(response.total ?? 0),
        page: Number(response.page ?? filters.page),
        pageSize: Number(response.pageSize ?? filters.pageSize),
    }
}

export async function getPaymentsAudit(
    companyId: string,
    filters: AuditFilters
): Promise<AuditPage> {
    return getAudit(companyId, "payments", filters)
}

export async function getTransactionsAudit(
    companyId: string,
    filters: AuditFilters
): Promise<AuditPage> {
    return getAudit(companyId, "transactions", filters)
}

export async function getMovementsAudit(
    companyId: string,
    filters: AuditFilters
): Promise<AuditPage> {
    return getAudit(companyId, "mouvements", filters)
}

export default { getPaymentsAudit, getTransactionsAudit, getMovementsAudit }
